import { NavigationStates } from './NavigationStates'
import { Personalization } from './Personalization'
import { Service } from './Service'
import { ToolStates } from './ToolStates'
import { UbrState } from './UbrState'
import { SwitchingState } from './SwitchingState'
import { ToolCategoryState } from './ToolCategoryState'
import { NotifState } from './NotifState'
import { ProductState } from './sales/Product'
import { BookingState } from './sales/Booking'
import { TrainingState } from './sales/Training'
import { Membership } from './sales/Membership'
import { TrainingState as SetupTrainingState } from './setup/Training'
import { MembershipState as SetupMembershipState } from './setup/Membership'
import { PropertyListState as SetupRP_PropertyListState} from './setup/realproperty/PropertyList'
import { RequestedPropertyListState as SetupRP_RequestedPropertyListState } from './setup/realproperty/RequestedPropertyList'
import { RealPropertyState as OnlineSolutionsECS_RealPropertyState } from './onlinesolutions/ecommercestore/RealProperty'
import { InquiriesState as SalesRP_InquriesState } from './sales/realproperty/Inquiries'
import { AgentApplicationState as SalesRP_AgentApplicationState } from './sales/realproperty/AgentApplications'
import { PropertyInquiriesState as SalesRP_PropertyInquiriesState} from './sales/realproperty/PropertyInquiries'
import { BookingState as ReportSales_BookingState } from './reports/sales/booking/BookingState'
import { ProductState as ReportSales_ProductState } from './reports/sales/product/ProductState'
import { SalesPage } from './campaign/salespage/SalesPage'
import { Payment } from './sales/Payment'
import { ReviewsRatings } from './sales/ReviewsRatings'
import { PromoProduct } from './campaign/promo/PromoProduct'
import { CreativeBrief } from './campaign/creativebrief/CreativeBrief'
import { Career as PosterCareer } from './campaign/poster/Career'
import { Training as PosterTraining } from './campaign/poster/Training'
import { CallMonitoring } from './campaign/callmonitoring/CallMonitoring'
import { SocialMediaState } from './reports/socialMediaInsight/SocialMediaState'

export const Context = () => {
    return {
        tool_state: ToolStates(),
        navigation_state: NavigationStates(),
        ubr_state:UbrState(),
        personalization_state: Personalization(),
        service_state: Service(),
        switching_state: SwitchingState(),
        tool_category_state: ToolCategoryState(),
        notif_state: NotifState(),
		// FEATURE CAMPAIGN
		creative_brief: CreativeBrief(),
		poster_career_state: PosterCareer(),
		poster_training_state: PosterTraining(),
		call_monitoring_state: CallMonitoring(),
        // FEATURE CAMPAIGN PROMO PRODUCT
        promo_product_state: PromoProduct(),
        // FEATURE SALES
        product_state: ProductState(),
        booking_state: BookingState(),
        training_state: TrainingState(),
        membership_state: Membership(),
		// FEATURE SALES -> REAL PROPERTY // rp = real property
		sales_rp_inquiries_state: SalesRP_InquriesState(),
		sales_rp_agentApplication_state: SalesRP_AgentApplicationState(),
		sales_rp_propertyInquiries_state: SalesRP_PropertyInquiriesState(), 
		// FEATURE SETUP
		setup_training_state: SetupTrainingState(),
		setup_membership_state: SetupMembershipState(),
		// FEATURE SETUP -> REAL PROPERTY // rp = Real Property
		setup_rp_propertyList_state: SetupRP_PropertyListState(),
		setup_rp_requestedPropertyList_state: SetupRP_RequestedPropertyListState(),
		// FEATURE ONLINE SOLUTIONS -> ECOMMERCE STORE // ecs = ecommerce store
		onlineSolutions_ecs_realProperty_state: OnlineSolutionsECS_RealPropertyState(),
		// FEATURE REPORTS
		payment_state: Payment(),
		reviews_state: ReviewsRatings(),
		// FEATURE REPORTS -> SALES
		reports_sales_booking_state: ReportSales_BookingState(),
		reports_sales_product_state: ReportSales_ProductState(),
        // FEATURE REPORTS -> SOCIAL MEDIA INSIGHT
        social_media_insight_state: SocialMediaState(),
		// SALES PAGE - TEMPORARY
		salespage_state: SalesPage(),
    }
}
